import { useState, useEffect } from "react";

interface CardProps {
  title: string;
  content: string;
  image: string;
}

export const Card = ({ title, content, image }: CardProps) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [image]);

  return (
    <div className="group w-full h-[26rem] bg-gray-900/40 rounded-[2rem] border border-gray-800 shadow-xl backdrop-blur-md hover:border-violet-500/50 hover:shadow-2xl hover:shadow-violet-500/10 transition-all duration-500 flex flex-col overflow-hidden">
      <div className="w-full h-48 relative overflow-hidden">
        {!loaded && (
          <div className="absolute inset-0 bg-gray-800/50 animate-pulse" />
        )}
        <img
          src={image}
          alt={title}
          className={`object-cover w-full h-full transition-all duration-700 group-hover:scale-110 ${
            loaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setLoaded(true)}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent opacity-60" />
      </div>
      <div className="flex flex-col flex-1 p-6 space-y-3">
        {!loaded ? (
          <div className="space-y-3">
            <div className="h-6 bg-gray-800/50 rounded-full w-3/4 animate-pulse" />
            <div className="space-y-2">
              <div className="h-3 bg-gray-800/50 rounded-full w-full animate-pulse" />
              <div className="h-3 bg-gray-800/50 rounded-full w-5/6 animate-pulse" />
            </div>
          </div>
        ) : (
          <>
            <h2 className="text-xl font-bold text-white group-hover:text-violet-400 transition-colors duration-300">
              {title}
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed line-clamp-4 flex-1">
              {content}
            </p>
            <div className="pt-2 flex items-center text-violet-500 font-bold text-xs uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
              Explore Details
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 ml-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
